import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';
import LeaveTypeList from './pages/private/LeaveTypeList';
import {partTimeJobIds, GetStoreRole, yearNames} from '../const/constant';
import API from '../middleware/API';

class SalaryCSV extends Component {
  constructor(props) {
    super(props);
    this.state={
      currentRole: GetStoreRole(localStorage.getItem('current_store_id'))
    }
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
    this.fileInput = React.createRef();
  }

  handleSaveWorkTime(e) {
    e.preventDefault();
    const { toggleOpen, longLeave,editTarget } = this.props;
    const { selectDate, selectStartTime,  selectEndTime, staff, reason, leaveType,currentRole} = this.state;
    if (editTarget.year == 0) {
      swal({
        type: 'error',
        title: '尚未選取年',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } else if (editTarget.month == 0) {
      swal({
        type: 'error',
        title: '尚未選取月',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } else if (this.fileInput.current.files.length == 0) {
      swal({
        type: 'error',
        title: '未選擇檔案',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } 

    this.props.saveWorkRecordFunc(this.fileInput.current.files[0]);
    toggleOpen();
  }

  render() {
    let { isVisible, toggleOpen, editTarget, onChangeFunc } = this.props;

    if (!isVisible) {
      return null;
    }

    let isDisable = false;
    if( editTarget.year == 0 || editTarget.month == 0 )
      isDisable = true;
    

    return (
    <div className="p-staff-list">
        <div className="u-editblock fadeIn" onClick={toggleOpen}>
              <div className="form-block" style={{maxWidth:'80%'}} onClick={(e)=>{e.stopPropagation();}}>
    <div className="u-small-title">上傳薪資</div>
                <form className="u-form">
                  <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>年：</label>
                      <select value={Number(editTarget.year)} className="u-form__select" 
                        onChange={(e)=>{onChangeFunc('year', e);}}
                      >
                        <option value="0" disabled>請選擇</option>
                        {
                          yearNames.map(yearName => (
                            <option key={yearName} value={yearName}>{ yearName }</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>月：</label>
                      <select value={Number(editTarget.month)} className="u-form__select" 
                        onChange={(e)=>{onChangeFunc('month', e);}}
                      >
                        <option value="0" disabled>請選擇</option>
                        <option key="1" value="1">1</option>
                        <option key="2" value="2">2</option>
                        <option key="3" value="3">3</option>
                        <option key="4" value="4">4</option>
                        <option key="5" value="5">5</option>
                        <option key="6" value="6">6</option>
                        <option key="7" value="7">7</option>
                        <option key="8" value="8">8</option>
                        <option key="9" value="9">9</option>
                        <option key="10" value="10">10</option>
                        <option key="11" value="11">11</option>
                        <option key="12" value="12">12</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>附件：</label>
                      <input type="file" accept="csv/*" ref={this.fileInput}/>
                    </div>
                    <div className="col-6 col-pad-12">
                      (上傳格式為csv，請務必把千分位的逗號拿掉!)
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-12 col-pad-12">
                      <div className="u-btn-group right">
                        {/* disable if 補休時數 <= 0} */}
                        <button type="button" className={"btn btn-md " + (isDisable ? 'cancel' : 'save')} disabled={isDisable} onClick={this.handleSaveWorkTime}>上傳</button>
                        <button type="button" className="btn btn-md cancel m-l-16" onClick={
                          (e) => {
                            e.preventDefault();
                            toggleOpen();
                          }
                        }>取消</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
      </div>
    )
  }
}

export default SalaryCSV;